const viewSelector = '.column-nav__inner'
const columnSelector = '.column-nav__column'
const itemSelector = '.column-nav__item'
const linkSelector = '.column-nav__link'
const backSelector = '.column-nav__back'
const focusableSelector = `${linkSelector}, ${backSelector}`

function columnNav(el) {

    // view
    const topPane = el.querySelector(columnSelector)
    const view = el.querySelector(viewSelector)

    // state
    let updateId = 0
    const activePanes = [topPane]
    const current = () => activePanes[activePanes.length - 1]

    // navigation
    function openSubmenu(link) {
        const item = link.closest(itemSelector)
        const pane = item.querySelector(columnSelector)
        if (!pane) return false
        // already showing this pane, ignore
        if (pane === current()) return true
        activePanes.push(pane)
        updateView(pane.querySelector(focusableSelector))
        return true
    }

    function back() {
        if (activePanes.length === 1) return
        const pane = activePanes.pop()
        // focus the link that opened the pane (the pane lives inside its item)
        updateView(pane.closest(itemSelector).querySelector(linkSelector))
    }

    function backToTop() {
        activePanes.length = 1
        updateView(current().querySelector(focusableSelector))
    }

    // rendering
    function updateView(focus = null) {
        const currentUpdateId = ++updateId
        const currentPane = current()

        el.style.pointerEvents = 'none'
        el.style.setProperty('--current-depth', activePanes.length - 1)
        updateTabindex()

        // apply the new pane state before the slide starts
        const allPanes = el.querySelectorAll(columnSelector)
        for (const pane of allPanes) {
            pane.classList.toggle('current', pane === currentPane)
            if (activePanes.includes(pane)) pane.classList.add('active')
        }

        if (focus) focus.focus({ preventScroll: true })

        afterTransition(view, () => {
            // cancel rapid back/forward navigations
            if (currentUpdateId !== updateId) return
            el.style.pointerEvents = ''
            // hide old panes after the transition/animation
            for (const pane of allPanes) {
                if (!activePanes.includes(pane)) pane.classList.remove('active')
            }
        })
    }

    function updateTabindex() {
        const pane = current()
        // closest() finds the link's pane, only set the current pane to be keyboard-reachable
        for (const focusable of el.querySelectorAll(focusableSelector)) {
            focusable.tabIndex = focusable.closest(columnSelector) === pane ? 0 : -1
        }
    }

    // input
    function onLinkClick(event) {
        if (openSubmenu(event.currentTarget)) event.preventDefault()
    }

    function onLinkKeydown(event) {
        if (event.code !== 'Space') return
        event.preventDefault()
        if (!openSubmenu(event.currentTarget)) event.currentTarget.click()
    }

    function onBackLinkClick(event) {
        event.preventDefault()
        back()
    }

    function setupEvents() {
        for (const link of el.querySelectorAll(linkSelector)) {
            link.addEventListener('click', onLinkClick)
            link.addEventListener('keydown', onLinkKeydown)
        }
        for (const button of el.querySelectorAll(backSelector)) {
            button.addEventListener('click', onBackLinkClick)
        }
    }

    // init
    topPane.classList.add('current', 'active')
    setupEvents()
    updateTabindex()

    return {
        back,
        backToTop
    }
}

function afterTransition(view, callback) {
    const duration = parseFloat(getComputedStyle(view).transitionDuration)
    if (!duration) return callback()
    const onTransitionEnd = event => {
        if (event.target !== view) return
        view.removeEventListener('transitionend', onTransitionEnd)
        callback()
    }
    view.addEventListener('transitionend', onTransitionEnd)
}

document.querySelectorAll('.column-nav').forEach(columnNav)
